import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:36
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/mfa/challenge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:36
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:36
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:36
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:36
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const challenge = {
    store: Object.assign(store, store),
}

export default challenge